/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';
import Accepted from './accepted-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Accepted {...validProps} />;
}
SvgComponent.iconName = 'accepted';

export const AcceptedIcon = svgIconWrapper(SvgComponent);
